import { useFormik } from 'formik';

import Input from 'components/shared/Input/Input';
import Modal from 'components/shared/Modal/Modal';
import Button from 'components/shared/Button/Button';
import DateInputPicker from 'components/shared/DateInputPicker/DateInputPicker';

import { VERIFY_PATIENT_INITIAL_VALUES, verifyPatientSchema } from './lib/helpers';

const VerifyPatient = ({ isOpen, handleClose, onVerify, isLoading }) => {
  const formik = useFormik({
    initialValues: VERIFY_PATIENT_INITIAL_VALUES,
    validationSchema: verifyPatientSchema,
    validateOnChange: false,
    onSubmit: (values) => onVerify(values)
  });

  return (
    <Modal
      isOpen={isOpen}
      handleClose={handleClose}
      onAfterClose={() => formik.resetForm()}
      title="Patient sign-in"
      isCentered
      footer={
        <Button
          text="Sign in"
          buttonType="submit"
          form="verify-patient"
          className="ml-auto"
          isLoading={isLoading}
        />
      }>
      <form id="verify-patient" onSubmit={formik.handleSubmit} className="flex flex-col gap-4">
        <p className="text-sm text-neutral-600">
          Confirm your details to see the patient information on this invoice.
        </p>
        <Input
          label="First name"
          name="firstName"
          placeholder="Enter your first name"
          value={formik.values.firstName}
          onChange={formik.handleChange}
          error={formik.errors.firstName}
          formik={formik}
          validateName
          focusNextFieldOnEnter
        />
        <Input
          label="Last name"
          name="lastName"
          placeholder="Enter your last name"
          value={formik.values.lastName}
          onChange={formik.handleChange}
          error={formik.errors.lastName}
          formik={formik}
          validateName
          submitFormOnEnter
        />
        <DateInputPicker
          label="Date of birth"
          isDateOnly
          value={formik.values.date}
          onChange={(date) => formik.setFieldValue('date', date)}
          error={formik.errors.date}
        />
      </form>
    </Modal>
  );
};

export default VerifyPatient;
